<template>
    <Form ref="formValidate" :rules="ruleValidate" style="padding: 20px;" :model="formData" label-position="left"
        :label-width="100">
        <FormItem label="题目" prop="subject">
            <Input type="textarea" v-model="formData.subject.subject"></Input>
        </FormItem>
        <FormItem :label="'选项' + (i + 1)" v-for="(item, i) in formData.answer" prop="answer">
            <div style="display: flex; flex-direction: row; align-items: center;">
                <Input v-model="item.content" style="width: 85%;" placeholder="选项内容"></Input>
                <Input v-model="item.score" style="width: 15%; margin-left: 10px;"></Input>
            </div>
        </FormItem>
        <FormItem label="解析" prop="answer1">
            <Input type="textarea" v-model="formData.subject.answer"></Input>
        </FormItem>
        <Button @Click="addAnswer">添加选项</Button>
        <div style="display: flex; flex-direction: row-reverse; flex: 1;">
            <Button @click="save" type="info" style="margin-left: 10px;">{{ id ? '保存' : '新增' }}</Button>
            <Button @click="close" type="primary" style="margin-left: 10px;">取消</Button>
        </div>
    </Form>
</template>
<script>
import { update, getInfo } from "@/api/subject/index";
import { Button } from "view-ui-plus";

export default {
    name: "subjectModal",
    props: {
        id: {
            default: null,
            type: String
        }
    },
    data() {
        return {
            ruleValidate: {
                subject: [
                    { required: true, message: '题目不能为空' }
                ],
                answer: [
                    { required: true, message: '选项不能为空' }
                ]
            },
            formData: {
                subject: {
                    id: null,
                    subject: ''
                },
                answer: []
            }
        }
    },
    mounted() {

    },
    watch: {
        id(newId) {
            this.formData.subject.id = newId;
            if (newId) {
                this.getData();
            } else {
                this.formData = {
                    subject: {
                        id: null,
                        subject: ''
                    },
                    answer: []
                }
            }

        }
    },
    methods: {
        getData() {
            getInfo(this.formData.subject.id).then(res => {
                if (res.code == 0) {
                    this.formData = res.data
                }
            })
        },
        save() {
            this.$refs.formValidate.validate((valid) => {
                if (valid) {
                    update(this.formData).then(res => {
                        if (res.code == 0) {
                            this.$Message.success(res.msg);
                            this.$emit('save');
                        }
                    })
                }
            })
        },
        close() {
            this.$emit('close');
        },
        addAnswer() {
            let answers = this.formData.answer
            let answer = {
                id: "",
                content: "",
                sort: this.formData.answer.length,
                score: 0
            }
            this.formData.answer = answers.concat(answer)
        }
    }
}
</script>
<style></style>